exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#company {\n  font-size: 15px; }\n\n.form-group {\n  width: 20% !important; }\n\n.custom-dropzone, .form-dropbox {\n  width: 100% !important; }\n", "", {"version":3,"sources":["/Users/jean-philippe/_work/rs-webapp/rs-lightbox-old/client/app/pages/company/company.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB,EAAE;;AAE1B;EACE,uBAAuB,EAAE","file":"company.scss","sourcesContent":["#company {\n  font-size: 15px; }\n\n.form-group {\n  width: 20% !important; }\n\n.custom-dropzone, .form-dropbox {\n  width: 100% !important; }\n"],"sourceRoot":""}]);

// exports
